<template>
  <router-view />
</template>

<style lang="less">
@import url('./assets/comm.css');
#app {
  height: 100vh;
  overflow: hidden;
}
</style>
